/**
 * @generated SignedSource<<88e2a8a9e6956e4cf57fa4ce70f6b607>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SessionsForm_FocusGroupSlotEditor_slot$data = {
  readonly countOfBookedSlots: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"InputSlotDetails_slot">;
  readonly " $fragmentType": "SessionsForm_FocusGroupSlotEditor_slot";
};
export type SessionsForm_FocusGroupSlotEditor_slot$key = {
  readonly " $data"?: SessionsForm_FocusGroupSlotEditor_slot$data;
  readonly " $fragmentSpreads": FragmentRefs<"SessionsForm_FocusGroupSlotEditor_slot">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SessionsForm_FocusGroupSlotEditor_slot",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countOfBookedSlots",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InputSlotDetails_slot"
    }
  ],
  "type": "StudyAvailabilitySlotNode",
  "abstractKey": null
};

(node as any).hash = "827c70afde08bcada295b8a60946934b";

export default node;
